import { render } from "./AddCSView.vue?vue&type=template&id=b3644a2a&scoped=true"
import script from "./AddCSView.vue?vue&type=script&lang=js"
export * from "./AddCSView.vue?vue&type=script&lang=js"

import "./AddCSView.vue?vue&type=style&index=0&id=b3644a2a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3644a2a"]])

export default __exports__